import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .fullname
  .email
  .organization(o => o.name)
  .roles(b => b.name)    
  .toString();
